import { DialogType } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { ModalInstance, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { EditGroupSetDialog } from '../../components/editGroupSet/EditGroupSetDialog';
import { IGroupSetInfo } from '../../models/IGroupSetInfo';

function showEditGroupSetDialog(groupSet: IGroupSetInfo): Promise<any> {
    let modalInstance: ModalInstance;
    const dialogProps = {
        dismiss: () => modalInstance && modalInstance.dismiss('cancel'),
        close: (result: any) => modalInstance && modalInstance.close(result),
        groupSet: groupSet
    };

    modalInstance = ReactModalService.open({
        type: DialogType.NormalWithTitleBar,
        dialogContent: React.createElement(EditGroupSetDialog, dialogProps),
        testId: 'editGroupSet',
        showCloseButton: true,
        dialogBodyStyle: {overflow: 'hidden'},
        dialogWidth: TabDialogWidth.width650px,
        title: Messages.editGroupSet_title()
    });

    return Promise.resolve(modalInstance.result);
}

export const EditGroupSetDialogAction = {
    showEditGroupSetDialog
};